import { GET_NOTIFICATIONS } from "../Action/type";

const initialState = {
    notificationList: [],
    count: 0,
    ureadCount: 0
};
export default function (state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
        case GET_NOTIFICATIONS:
            return {
                ...state,
                notificationList: payload.notifications,
                count: payload?.count,
                ureadCount: payload?.ureadCount
            };

        case "DECREASE_UNREAD_COUNT":
            return {
                ...state,
                ureadCount: state.ureadCount > 0 ? state.ureadCount - 1 : 0,
            };

        case "MARK_NOTIFICATION_READ_BY_ID": {
            const id = action.id;
            return {
                ...state,
                notificationList: (state.notificationList || []).map((n) =>
                    n && (n._id === id || n.id === id) ? { ...n, isRead: true } : n
                ),
            };
        }

        default:
            return state;
    }
}
